import React from 'react'
import PropTypes from 'prop-types'
import { MdChevronRight } from 'react-icons/md'
import { Link } from 'react-router-dom'
import BoxRounded from '../BoxRounded/BoxRounded'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import Avatar from '../Avatar/Avatar'
import styles from './productBox.module.scss'

const ProductBox = (props) => {
  const { title, description, to, image, onClick } = props

  const content = (
    <BoxRounded>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex flex="1" alignItems="center">
          <div className={styles.boxImage}>
            <Flex alignItems="flex-start" height="100%">
              <Avatar
                image={image}
                size="medium"
                title="logo product"
                radius={25}
              />
            </Flex>
          </div>
          <Flex column margin="0px 0px 0px 16px">
            <Text
              size="xs"
              color="gray"
              variation="dark"
              margin="0px 0px 4px 0px"
            >
              {title}
            </Text>
            <Text size="xxxs" color="gray" variation="light">
              {description?.value}
            </Text>
          </Flex>
        </Flex>
        <Flex>
          <MdChevronRight size={25} />
        </Flex>
      </Flex>
    </BoxRounded>
  )

  if (onClick)
    return (
      <div className={styles.link} onClick={onClick}>
        {content}
      </div>
    )

  return <Link to={to}>{content}</Link>
}

ProductBox.defaultProps = {
  image: null,
  onClick: null,
  to: null
}

ProductBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    value: PropTypes.string
  }).isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  image: PropTypes.string
}

export default ProductBox
